module.exports = "https://web-assets.ifttt.com/packs/media/connect/triangle-f9506208.svg";